// extracted by mini-css-extract-plugin
module.exports = {"faq":"_3-QJx","wrap":"RpLWp","title":"_2EpwA","active":"_32M8V","content":"_36r7-","contentHide":"_1XyuB"};